// Spanish translation

const es = {
  "account.statement.open": "Abrir",
  "account.statement.close": "Cerrar",
  "account.statement.expenses": "Ver Gastos",
  "account.statement.date": "Fecha",
  "account.statement.start_balance": "Saldo Base",
  "account.statement.line": "Pago / Anticipo",
  "account.statement.line.amount": "Valor",
  "account.statement.line.statement": "Medio de Pago",
  "account.statement.line.date": "Fecha",
  "account.statement.line.number": "Numero",
  "account.statement.line.party": "Tercero",
  "account.statement.open.msg_start":
    "Por favor, ingrese el saldo inicial para abrir los estados de cuenta...",
  "account.statement.open.msg_success":
    "Estados de cuenta abiertos exitosamente!",
  "account.statement.open.msg_error": "Falta la configuración del terminal!",
  "account.statement.close.msg_start":
    "Desea cerrar los estados de cuenta de su terminal?",
  "account.statement.close.msg_success":
    "Estados de cuenta cerrados exitosamente!",
  "account.statement.close.msg_error": "Falta la configuración del terminal!",
  "account.statement.create_uid": "Creado por",
  "account.statement.tips": "Ver Propinas",
  "account.statement.sale.delivery": "Domicilios",
  "account.statement.sale.tips": "Propinas",
  "account.statement.sale.total": "Total",
  "account_statement.advanced.report": "Cuadre de Caja Global",
  "account_statement.cash_up.report": "Cuadre de Caja Individual",
  "sale_pos.expenses_daily.invoice_number": "Número de factura",
  "sale_pos.expenses_daily.description": "Descripción",
  "sale_pos.expenses_daily.amount": "Valor",
  "sale_pos.expenses_daily.party": "Proveedor",
  "sale_pos.expenses_daily.reference": "Referencia",
  "sale_pos.expenses_daily": "Gastos Diarios",
  "sale_pos.expenses_daily.statement": "Estado de cuenta",
  "sale_pos.expenses_daily.create_uid": "Creado por",
};

export default es;
